(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-pdp"] && !Shopify.designMode) return;
  try {
    
    if (!window.__VideoStoriesMediaManager) {
      window.__VideoStoriesMediaManager = {
        isMounted(container) {
          return container?.dataset.vscMounted === 'true';
        },
        parseSources(container) {
          const raw = container.dataset.vscSources;
          if (!raw) return [];
          try { return JSON.parse(raw); } catch { return []; }
        },
        getPipMediaClass() {
          return 'video-stories-pip__video';
        },
        getModalMediaClass(container) {
          return container.dataset.vscMediaType === 'external_video'
            ? 'video-stories-modal__external-video'
            : 'video-stories-modal__video';
        },
        buildExternalSrc(container, { autoplay = false, muted = true } = {}) {
          const rawSrc = container.dataset.vscExternalSrc;
          if (!rawSrc) return '';
          const host = container.dataset.vscExternalHost;
          const base = rawSrc.startsWith('http') ? rawSrc : `https:${rawSrc}`;
          const url = new URL(base);
          if (host === 'youtube') {
            url.searchParams.set('autoplay', autoplay ? '1' : '0');
            url.searchParams.set('mute', muted ? '1' : '0');
            return url.toString();
          }
          url.searchParams.set('autoplay', autoplay ? '1' : '0');
          url.searchParams.set('muted', muted ? '1' : '0');
          return url.toString();
        },
        ensurePosterLayer(container) {
          if (!container) return null;
          container.style.backgroundImage = '';
          let layer = container.querySelector('.vsc-poster-layer');
          if (!layer) {
            layer = document.createElement('div');
            layer.className = 'vsc-poster-layer';
            layer.setAttribute('aria-hidden', 'true');
            container.prepend(layer);
          }
          const poster = container.dataset.vscPoster;
          if (poster) {
            layer.style.backgroundImage = `url("${poster}")`;
            layer.classList.remove('is-hidden');
          }
          return layer;
        },
        ensureLoading(container) {
          if (!container) return null;
          let loader = container.querySelector('.vsc-media-loading');
          if (!loader) {
            loader = document.createElement('div');
            loader.className = 'vsc-media-loading';
            loader.innerHTML = '<span></span>';
            container.appendChild(loader);
          }
          container.dataset.vscLoading = 'true';
          return loader;
        },
        setMediaReady(container, element) {
          if (!container || container.dataset.vscLoading === 'false') return;
          container.dataset.vscLoading = 'false';
          container.querySelector('.vsc-poster-layer')?.classList.add('is-hidden');
          if (element) element.classList.add('is-ready');
        },
        bindReadyListeners(container, element) {
          if (!container || !element) return;
          const markReady = () => this.setMediaReady(container, element);
          if (element.tagName === 'VIDEO') {
            if (element.readyState >= 3) markReady();
            else {
              element.addEventListener('canplay', markReady, { once: true });
              element.addEventListener('playing', markReady, { once: true });
            }
            setTimeout(markReady, 8000);
          } else if (element.tagName === 'IFRAME') {
            element.addEventListener('load', markReady, { once: true });
            setTimeout(markReady, 8000);
          }
        },
        mountHosted(container, { loop, muted, className }) {
          const sources = this.parseSources(container);
          if (sources.length === 0) return null;
          const video = document.createElement('video');
          video.preload = 'metadata';
          video.playsInline = true;
          video.muted = muted;
          video.defaultMuted = muted;
          if (muted) video.setAttribute('muted', '');
          video.loop = loop;
          video.controls = false;
          className.split(' ').filter(Boolean).forEach((c) => video.classList.add(c));
          sources.forEach((source) => {
            const s = document.createElement('source');
            s.src = source.url;
            s.type = source.mime_type;
            video.appendChild(s);
          });
          container.appendChild(video);
          video.load();
          return video;
        },
        mountExternal(container, { autoplay, muted, className }) {
          const src = this.buildExternalSrc(container, { autoplay, muted });
          if (!src) return null;
          const iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('frameborder', '0');
          className.split(' ').filter(Boolean).forEach((c) => iframe.classList.add(c));
          container.appendChild(iframe);
          return iframe;
        },
        mount(container, options = {}) {
          if (!container || this.isMounted(container)) return this.getMediaElement(container);
          this.ensurePosterLayer(container);
          this.ensureLoading(container);
          const mediaType = container.dataset.vscMediaType;
          const loop = container.dataset.vscLoop === 'true';
          const { autoplay = false, muted = true, context = 'pip' } = options;
          const className = context === 'modal' ? this.getModalMediaClass(container) : this.getPipMediaClass();
          let element = null;
          if (mediaType === 'video' || mediaType === 'metafield') {
            element = this.mountHosted(container, { loop, muted, className });
          } else if (mediaType === 'external_video') {
            element = this.mountExternal(container, { autoplay, muted, className });
          }
          if (element) {
            container.dataset.vscMounted = 'true';
            this.bindReadyListeners(container, element);
          }
          return element;
        },
        unmount(container) {
          if (!container) return;
          container.querySelector('video')?.remove();
          const iframe = container.querySelector('iframe');
          if (iframe) { iframe.src = 'about:blank'; iframe.remove(); }
          container.querySelector('.vsc-media-loading')?.remove();
          container.dataset.vscMounted = 'false';
          container.dataset.vscLoading = 'false';
          this.restorePoster(container);
        },
        restorePoster(container) {
          if (!container) return;
          container.dataset.vscLoading = 'false';
          this.ensurePosterLayer(container);
          container.querySelector('.vsc-media-loading')?.remove();
        },
        getMediaElement(container) {
          return container?.querySelector('video, iframe') || null;
        },
        pause(container) {
          container?.querySelector('video')?.pause();
        },
        playHosted(container) {
          const video = container?.querySelector('video');
          if (!video) return;
          video.muted = true;
          const tryPlay = () => video.play().catch(() => setTimeout(tryPlay, 300));
          if (video.readyState >= 2) tryPlay();
          else video.addEventListener('canplay', tryPlay, { once: true });
        }
      };
    }

    const VSWMedia = window.__VideoStoriesMediaManager;

    function vswPauseAllPageVideos() {
      document.querySelectorAll('video').forEach((v) => v.pause());
    }

    class VideoStoriesProductWidget {
      constructor(section) {
        this.section = section;
        this.pipContainer = section.querySelector('.video-stories-pip__inner[data-vsc-media]');
        this.autoplayEnabled = section.dataset.videoAutoplay === 'true';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.suspended = false;
        this.modal = section.querySelector('.video-stories-modal');

        if (this.pipContainer) {
          VSWMedia.restorePoster(this.pipContainer);
          if (this.autoplayEnabled && !this.reducedMotion) this.resumeVisible();
        }

        if (this.modal) {
          this.storiesModal = new VSWProductStoriesModal(section, this);
        }
      }

      resumeVisible() {
        if (this.suspended || !this.pipContainer) return;
        const isExternal = this.pipContainer.dataset.vscMediaType === 'external_video';
        VSWMedia.unmount(this.pipContainer);
        VSWMedia.mount(this.pipContainer, {
          autoplay: isExternal,
          muted: true,
          context: 'pip'
        });
        if (!isExternal) VSWMedia.playHosted(this.pipContainer);
      }

      suspendAll() {
        this.suspended = true;
        if (this.pipContainer) VSWMedia.unmount(this.pipContainer);
      }

      destroy() {
        this.suspended = true;
        if (this.pipContainer) VSWMedia.unmount(this.pipContainer);
        this.storiesModal?.destroy();
      }
    }

    class VSWProductStoriesModal {
      constructor(section, host) {
        this.section = section;
        this.host = host;
        this.modal = section.querySelector('.video-stories-modal');
        this.stories = Array.from(section.querySelectorAll('.video-stories-modal__story'));
        this.progressEl = section.querySelector('[data-story-progress]');
        this.currentIndex = 0;
        this.isMuted = true;
        this.progressRaf = null;
        if (!this.modal || this.stories.length === 0) return;
        this.buildProgress();
        this.bindEvents();
      }

      bindEvents() {
        this.section.querySelectorAll('[data-story-open]').forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.open(parseInt(trigger.dataset.storyOpen, 10));
          });
        });
        this.modal.querySelectorAll('[data-story-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.modal.querySelectorAll('[data-story-prev]').forEach((el) => el.addEventListener('click', () => this.prev()));
        this.modal.querySelectorAll('[data-story-next]').forEach((el) => el.addEventListener('click', () => this.next()));
        this.modal.querySelectorAll('[data-story-mute]').forEach((el) => el.addEventListener('click', () => this.toggleMute()));
        document.addEventListener('keydown', (event) => {
          if (!this.modal.classList.contains('is-open')) return;
          if (event.key === 'Escape') this.close();
          if (event.key === 'ArrowLeft') this.prev();
          if (event.key === 'ArrowRight') this.next();
        });
      }

      buildProgress() {
        if (!this.progressEl) return;
        this.progressEl.innerHTML = '';
        this.stories.forEach(() => {
          const segment = document.createElement('div');
          segment.className = 'video-stories-modal__progress-segment';
          const fill = document.createElement('span');
          fill.className = 'video-stories-modal__progress-fill';
          segment.appendChild(fill);
          this.progressEl.appendChild(segment);
        });
        this.segments = Array.from(this.progressEl.querySelectorAll('.video-stories-modal__progress-segment'));
      }

      getStoryMediaContainer(story) {
        return story?.querySelector('[data-vsc-media]') || null;
      }

      open(index) {
        this.currentIndex = Math.max(0, Math.min(index, this.stories.length - 1));
        this.modal.hidden = false;
        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('video-stories-modal-open');
        this.host.suspendAll();
        vswPauseAllPageVideos();
        this.syncMuteButtons();
        this.showStory(this.currentIndex);
      }

      close() {
        this.pauseAllStories();
        this.stories.forEach((story) => {
          const c = this.getStoryMediaContainer(story);
          if (c) { VSWMedia.unmount(c); VSWMedia.restorePoster(c); }
        });
        cancelAnimationFrame(this.progressRaf);
        this.modal.classList.remove('is-open');
        this.modal.hidden = true;
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('video-stories-modal-open');
        this.host.suspended = false;
        this.host.resumeVisible();
      }

      prev() {
        if (this.currentIndex > 0) this.showStory(this.currentIndex - 1);
        else this.close();
      }

      next() {
        if (this.currentIndex < this.stories.length - 1) this.showStory(this.currentIndex + 1);
        else this.close();
      }

      showStory(index) {
        this.currentIndex = index;
        this.stories.forEach((story, i) => {
          story.classList.remove('is-active', 'is-adjacent');
          if (i === index) story.classList.add('is-active');
          else if (i === index - 1 || i === index + 1) story.classList.add('is-adjacent');
        });
        this.stories.forEach((story) => {
          const c = this.getStoryMediaContainer(story);
          if (c) { VSWMedia.unmount(c); VSWMedia.restorePoster(c); }
        });
        const active = this.getStoryMediaContainer(this.stories[index]);
        if (active) {
          VSWMedia.mount(active, {
            autoplay: active.dataset.vscMediaType === 'external_video',
            muted: this.isMuted,
            context: 'modal'
          });
        }
        this.updateProgressUI();
        this.playActiveStory();
      }

      getActiveVideo() {
        const el = VSWMedia.getMediaElement(this.getStoryMediaContainer(this.stories[this.currentIndex]));
        return el?.tagName === 'VIDEO' ? el : null;
      }

      playActiveStory() {
        this.pauseAllStories();
        const container = this.getStoryMediaContainer(this.stories[this.currentIndex]);
        const element = container ? VSWMedia.getMediaElement(container) : null;
        if (!element || element.tagName !== 'VIDEO') {
          this.startFallbackProgress(element?.tagName === 'IFRAME' ? 15000 : 5000);
          return;
        }
        element.currentTime = 0;
        element.muted = this.isMuted;
        const start = () => {
          element.play().catch(() => {});
          element.onended = () => this.next();
          this.trackProgress(element);
        };
        if (element.readyState >= 2) start();
        else element.addEventListener('loadeddata', start, { once: true });
      }

      pauseAllStories() {
        this.stories.forEach((story) => {
          const c = this.getStoryMediaContainer(story);
          if (c) {
            VSWMedia.pause(c);
            c.querySelector('video') && (c.querySelector('video').onended = null);
          }
        });
        cancelAnimationFrame(this.progressRaf);
      }

      trackProgress(video) {
        const fill = this.segments[this.currentIndex]?.querySelector('.video-stories-modal__progress-fill');
        if (!fill) return;
        const update = () => {
          if (!video.duration || Number.isNaN(video.duration)) {
            this.progressRaf = requestAnimationFrame(update);
            return;
          }
          fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
          if (!video.paused && !video.ended) this.progressRaf = requestAnimationFrame(update);
        };
        cancelAnimationFrame(this.progressRaf);
        this.progressRaf = requestAnimationFrame(update);
      }

      startFallbackProgress(duration) {
        const fill = this.segments[this.currentIndex]?.querySelector('.video-stories-modal__progress-fill');
        if (!fill) return;
        const start = performance.now();
        const tick = (now) => {
          const p = Math.min((now - start) / duration, 1);
          fill.style.width = `${p * 100}%`;
          if (p < 1) this.progressRaf = requestAnimationFrame(tick);
          else this.next();
        };
        cancelAnimationFrame(this.progressRaf);
        this.progressRaf = requestAnimationFrame(tick);
      }

      updateProgressUI() {
        this.segments.forEach((segment, i) => {
          const fill = segment.querySelector('.video-stories-modal__progress-fill');
          segment.classList.toggle('is-complete', i < this.currentIndex);
          if (fill) fill.style.width = i < this.currentIndex ? '100%' : '0%';
        });
      }

      syncMuteButtons() {
        this.modal.querySelectorAll('[data-story-mute]').forEach((btn) => {
          btn.classList.toggle('is-muted', this.isMuted);
        });
      }

      toggleMute() {
        this.isMuted = !this.isMuted;
        const video = this.getActiveVideo();
        if (video) video.muted = this.isMuted;
        this.syncMuteButtons();
      }

      destroy() {
        cancelAnimationFrame(this.progressRaf);
      }
    }

    function initVideoStoriesProductWidget(section) {
      if (!section || section.dataset.vswJsReady === 'true') return;
      section._videoStoriesProductWidget?.destroy?.();
      section._videoStoriesProductWidget = new VideoStoriesProductWidget(section);
      section.dataset.vswJsReady = 'true';
    }

    document.querySelectorAll('.video-stories-product-widget[data-section-id]').forEach(initVideoStoriesProductWidget);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.video-stories-product-widget[data-section-id]');
      if (section) delete section.dataset.vswJsReady;
      initVideoStoriesProductWidget(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.video-stories-product-widget[data-section-id]');
      if (section?._videoStoriesProductWidget?.destroy) {
        section._videoStoriesProductWidget.destroy();
        delete section._videoStoriesProductWidget;
        delete section.dataset.vswJsReady;
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoStoriesCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.video-stories-carousel__track');
      this.prevBtn = section.querySelector('.video-stories-carousel__nav--prev');
      this.nextBtn = section.querySelector('.video-stories-carousel__nav--next');
      this.slides = section.querySelectorAll('.video-stories-carousel__slide');
      this.videos = section.querySelectorAll('.video-stories-carousel__video-inner video');
      this.autoplayEnabled = section.dataset.videoAutoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.modal = section.querySelector('.video-stories-modal');

      if (!this.track || this.slides.length === 0) return;

      this.bindEvents();
      this.updateNavState();
      this.prepareCarouselVideos();

      if (this.autoplayEnabled && !this.reducedMotion) {
        this.initAutoplay();
      }

      if (this.modal) {
        this.storiesModal = new VideoStoriesModal(section, this);
      }
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn?.addEventListener('click', () => this.scroll('next'));
      this.track.addEventListener('scroll', () => {
        this.updateNavState();
        this.playVisibleCarouselVideos();
      }, { passive: true });
      window.addEventListener('resize', () => {
        this.updateNavState();
        this.playVisibleCarouselVideos();
      }, { passive: true });
    }

    prepareCarouselVideos() {
      this.videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.controls = false;
        video.removeAttribute('controls');
        video.playsInline = true;
        video.disablePictureInPicture = true;
        video.setAttribute('disablepictureinpicture', '');

        video.addEventListener('loadeddata', () => this.playCarouselVideo(video));
        video.addEventListener('canplay', () => this.playCarouselVideo(video));
      });
    }

    playCarouselVideo(video) {
      if (!video || !this.autoplayEnabled) return;
      if (!this.isVideoVisibleInTrack(video)) return;

      video.muted = true;
      video.defaultMuted = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          setTimeout(() => this.playCarouselVideo(video), 300);
        });
      }
    }

    isVideoVisibleInTrack(video) {
      const trackRect = this.track.getBoundingClientRect();
      const videoRect = video.getBoundingClientRect();
      return videoRect.right > trackRect.left + 4 && videoRect.left < trackRect.right - 4;
    }

    playVisibleCarouselVideos() {
      if (!this.autoplayEnabled || this.reducedMotion) return;

      this.videos.forEach((video) => {
        if (this.isVideoVisibleInTrack(video)) {
          this.playCarouselVideo(video);
        } else {
          video.pause();
        }
      });
    }

    initAutoplay() {
      this.playVisibleCarouselVideos();

      requestAnimationFrame(() => this.playVisibleCarouselVideos());
      setTimeout(() => this.playVisibleCarouselVideos(), 100);
      setTimeout(() => this.playVisibleCarouselVideos(), 500);
      setTimeout(() => this.playVisibleCarouselVideos(), 1500);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                this.playCarouselVideo(video);
              } else {
                video.pause();
              }
            });
          },
          { root: this.track, threshold: 0.25 }
        );

        this.videos.forEach((video) => observer.observe(video));
      }
    }

    getScrollAmount() {
      const slide = this.slides[0];
      if (!slide) return 0;
      const gap = parseFloat(getComputedStyle(this.section).getPropertyValue('--vsc-gap')) || 16;
      return slide.offsetWidth + gap;
    }

    scroll(direction) {
      const amount = this.getScrollAmount();
      this.track.scrollBy({
        left: direction === 'next' ? amount : -amount,
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });
    }

    updateNavState() {
      if (!this.prevBtn || !this.nextBtn) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const tolerance = 2;

      this.prevBtn.disabled = this.track.scrollLeft <= tolerance;
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - tolerance;
    }

  }

  class VideoStoriesModal {
    constructor(section, carousel) {
      this.section = section;
      this.carousel = carousel;
      this.modal = section.querySelector('.video-stories-modal');
      this.stories = Array.from(section.querySelectorAll('.video-stories-modal__story'));
      this.progressEl = section.querySelector('[data-story-progress]');
      this.currentIndex = 0;
      this.isMuted = true;
      this.progressRaf = null;

      if (!this.modal || this.stories.length === 0) return;

      this.buildProgress();
      this.bindEvents();
    }

    bindEvents() {
      this.section.querySelectorAll('[data-story-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const index = parseInt(trigger.dataset.storyOpen, 10);
          this.open(index);
        });
      });

      this.modal.querySelectorAll('[data-story-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.modal.querySelectorAll('[data-story-prev]').forEach((el) => {
        el.addEventListener('click', () => this.prev());
      });

      this.modal.querySelectorAll('[data-story-next]').forEach((el) => {
        el.addEventListener('click', () => this.next());
      });

      this.modal.querySelectorAll('[data-story-mute]').forEach((el) => {
        el.addEventListener('click', () => this.toggleMute());
      });

      this.modal.querySelectorAll('[data-add-to-cart]').forEach((el) => {
        el.addEventListener('click', () => this.addToCart(el));
      });

      document.addEventListener('keydown', (event) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.prev();
        if (event.key === 'ArrowRight') this.next();
      });
    }

    buildProgress() {
      if (!this.progressEl) return;
      this.progressEl.innerHTML = '';
      this.stories.forEach((_, index) => {
        const segment = document.createElement('div');
        segment.className = 'video-stories-modal__progress-segment';
        segment.dataset.segmentIndex = index;
        const fill = document.createElement('span');
        fill.className = 'video-stories-modal__progress-fill';
        segment.appendChild(fill);
        this.progressEl.appendChild(segment);
      });
      this.segments = Array.from(this.progressEl.querySelectorAll('.video-stories-modal__progress-segment'));
    }

    open(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.stories.length - 1));
      this.modal.hidden = false;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('video-stories-modal-open');
      this.carousel.videos.forEach((video) => video.pause());
      this.showStory(this.currentIndex);
    }

    close() {
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('video-stories-modal-open');
      this.pauseAllStories();
      cancelAnimationFrame(this.progressRaf);
      this.carousel.playVisibleCarouselVideos();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.showStory(this.currentIndex - 1);
      } else {
        this.close();
      }
    }

    next() {
      if (this.currentIndex < this.stories.length - 1) {
        this.showStory(this.currentIndex + 1);
      } else {
        this.close();
      }
    }

    showStory(index) {
      this.currentIndex = index;
      this.stories.forEach((story, i) => {
        story.classList.remove('is-active', 'is-adjacent');
        if (i === index) {
          story.classList.add('is-active');
        } else if (i === index - 1 || i === index + 1) {
          story.classList.add('is-adjacent');
        }
      });
      this.updateProgressUI();
      this.playActiveStory();
    }

    getActiveVideo() {
      const story = this.stories[this.currentIndex];
      return story?.querySelector('.video-stories-modal__video') || null;
    }

    playActiveStory() {
      this.pauseAllStories();
      const video = this.getActiveVideo();
      if (!video) {
        this.startFallbackProgress(5000);
        return;
      }

      video.currentTime = 0;
      video.muted = this.isMuted;
      video.play().catch(() => {});
      video.onended = () => this.next();
      this.trackProgress(video);
    }

    pauseAllStories() {
      this.stories.forEach((story) => {
        const video = story.querySelector('.video-stories-modal__video');
        if (video) {
          video.pause();
          video.onended = null;
        }
      });
      cancelAnimationFrame(this.progressRaf);
    }

    trackProgress(video) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const update = () => {
        if (!video.duration || Number.isNaN(video.duration)) {
          this.progressRaf = requestAnimationFrame(update);
          return;
        }
        fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
        if (!video.paused && !video.ended) {
          this.progressRaf = requestAnimationFrame(update);
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(update);
    }

    startFallbackProgress(duration) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        fill.style.width = `${progress * 100}%`;
        if (progress < 1) {
          this.progressRaf = requestAnimationFrame(tick);
        } else {
          this.next();
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(tick);
    }

    updateProgressUI() {
      this.segments.forEach((segment, i) => {
        const fill = segment.querySelector('.video-stories-modal__progress-fill');
        segment.classList.toggle('is-complete', i < this.currentIndex);
        if (fill) fill.style.width = i < this.currentIndex ? '100%' : '0%';
      });
    }

    toggleMute() {
      this.isMuted = !this.isMuted;
      const video = this.getActiveVideo();
      if (video) video.muted = this.isMuted;

      this.modal.querySelectorAll('[data-story-mute]').forEach((btn) => {
        const onIcon = btn.querySelector('.video-stories-modal__mute-icon--on');
        const offIcon = btn.querySelector('.video-stories-modal__mute-icon--off');
        if (onIcon) onIcon.hidden = !this.isMuted;
        if (offIcon) offIcon.hidden = this.isMuted;
        btn.setAttribute('aria-label', this.isMuted ? 'Ativar som' : 'Desativar som');
      });
    }

    async addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adicionando...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });

        if (!response.ok) throw new Error('Cart error');

        button.textContent = 'Adicionado!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      } catch (error) {
        button.textContent = 'Erro ao adicionar';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      }
    }
  }

  function initVideoStoriesCarousels() {
    document.querySelectorAll('.video-stories-carousel[data-section-id]').forEach((section) => {
      section._videoStoriesCarousel = new VideoStoriesCarousel(section);
    });
  }

  initVideoStoriesCarousels();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.video-stories-carousel[data-section-id]');
    if (section) {
      section._videoStoriesCarousel = new VideoStoriesCarousel(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-stories-carousel"] && !Shopify.designMode) return;
  try {
    
  const VideoStoriesMediaManager = {
    isMounted(container) {
      return container?.dataset.vscMounted === 'true';
    },

    parseSources(container) {
      const raw = container.dataset.vscSources;
      if (!raw) return [];
      try {
        return JSON.parse(raw);
      } catch {
        return [];
      }
    },

    pickPreferredSources(sources) {
      const list = Array.isArray(sources) ? sources.filter((source) => source?.url) : [];
      if (!list.length) return [];

      const isHls = (source) => {
        const type = String(source.mime_type || '').toLowerCase();
        const url = String(source.url || '').toLowerCase();
        return type.includes('mpegurl') || type.includes('m3u8') || url.includes('.m3u8');
      };

      const isMp4 = (source) => {
        const type = String(source.mime_type || '').toLowerCase();
        const url = String(source.url || '').toLowerCase();
        return type.includes('mp4') || url.includes('.mp4');
      };

      const progressive = list.filter((source) => isMp4(source) && !isHls(source));
      const nonHls = list.filter((source) => !isHls(source));
      const pool = progressive.length ? progressive : (nonHls.length ? nonHls : list);

      const score = (source) => {
        const url = String(source.url || '').toLowerCase();
        if (url.includes('1080') || url.includes('7.2mbps') || url.includes('hd-1080')) return 100;
        if (url.includes('720') || url.includes('hd-720')) return 60;
        if (url.includes('480') || url.includes('1.5mbps') || url.includes('sd-480') || url.includes('/sd')) return 10;
        if (url.includes('360') || url.includes('low')) return 5;
        return 35;
      };

      return [...pool].sort((a, b) => score(a) - score(b)).slice(0, 1);
    },

    getCarouselMediaClass(container) {
      return container.dataset.vscMediaType === 'external_video'
        ? 'video-stories-carousel__external-video'
        : 'video-stories-carousel__video';
    },

    getModalMediaClass(container) {
      return container.dataset.vscMediaType === 'external_video'
        ? 'video-stories-modal__external-video'
        : 'video-stories-modal__video';
    },

    buildExternalSrc(container, { autoplay = false, muted = true } = {}) {
      const rawSrc = container.dataset.vscExternalSrc;
      if (!rawSrc) return '';

      const host = container.dataset.vscExternalHost;
      const base = rawSrc.startsWith('http') ? rawSrc : `https:${rawSrc}`;
      const url = new URL(base);

      if (host === 'youtube') {
        url.searchParams.set('autoplay', autoplay ? '1' : '0');
        url.searchParams.set('mute', muted ? '1' : '0');
        return url.toString();
      }

      url.searchParams.set('autoplay', autoplay ? '1' : '0');
      url.searchParams.set('muted', muted ? '1' : '0');
      return url.toString();
    },

    ensurePosterLayer(container) {
      if (!container) return null;

      container.style.backgroundImage = '';
      container.style.backgroundSize = '';
      container.style.backgroundPosition = '';

      let layer = container.querySelector('.vsc-poster-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'vsc-poster-layer';
        layer.setAttribute('aria-hidden', 'true');
        container.prepend(layer);
      }

      const poster = container.dataset.vscPoster;
      if (poster) {
        layer.style.backgroundImage = `url("${poster}")`;
        layer.classList.remove('is-hidden');
      } else {
        layer.style.backgroundImage = '';
      }

      return layer;
    },

    ensureLoading(container) {
      if (!container) return null;

      let loader = container.querySelector('.vsc-media-loading');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'vsc-media-loading';
        loader.setAttribute('aria-hidden', 'true');
        loader.innerHTML = '<span></span>';
        container.appendChild(loader);
      }

      container.dataset.vscLoading = 'true';
      return loader;
    },

    setMediaReady(container, element) {
      if (!container || container.dataset.vscLoading === 'false') return;

      container.dataset.vscLoading = 'false';

      const posterLayer = container.querySelector('.vsc-poster-layer');
      if (posterLayer) posterLayer.classList.add('is-hidden');

      if (element) element.classList.add('is-ready');
    },

    bindReadyListeners(container, element) {
      if (!container || !element) return;

      const markReady = () => this.setMediaReady(container, element);

      if (element.tagName === 'VIDEO') {
        if (element.readyState >= 3) {
          markReady();
        } else {
          element.addEventListener('canplay', markReady, { once: true });
          element.addEventListener('playing', markReady, { once: true });
        }
        setTimeout(markReady, 8000);
        return;
      }

      if (element.tagName === 'IFRAME') {
        element.addEventListener('load', markReady, { once: true });
        setTimeout(markReady, 8000);
      }
    },

    mountHosted(container, { loop, muted, className }) {
      const sources = this.pickPreferredSources(this.parseSources(container));
      if (sources.length === 0) return null;

      const video = document.createElement('video');
      video.preload = 'none';
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.muted = muted;
      video.defaultMuted = muted;
      if (muted) video.setAttribute('muted', '');
      video.loop = loop;
      video.controls = false;
      video.disablePictureInPicture = true;
      video.setAttribute('disablepictureinpicture', '');

      className.split(' ').filter(Boolean).forEach((name) => video.classList.add(name));

      sources.forEach((source) => {
        const sourceEl = document.createElement('source');
        sourceEl.src = source.url;
        if (source.mime_type) sourceEl.type = source.mime_type;
        video.appendChild(sourceEl);
      });

      container.appendChild(video);
      return video;
    },

    mountExternal(container, { autoplay, muted, className }) {
      const src = this.buildExternalSrc(container, { autoplay, muted });
      if (!src) return null;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('title', 'Video');
      className.split(' ').filter(Boolean).forEach((name) => iframe.classList.add(name));
      container.appendChild(iframe);
      return iframe;
    },

    mount(container, options = {}) {
      if (!container || this.isMounted(container)) {
        return this.getMediaElement(container);
      }

      this.ensurePosterLayer(container);
      this.ensureLoading(container);

      const mediaType = container.dataset.vscMediaType;
      const loop = container.dataset.vscLoop === 'true';
      const {
        autoplay = false,
        muted = true,
        context = 'carousel'
      } = options;

      const className = context === 'modal'
        ? this.getModalMediaClass(container)
        : this.getCarouselMediaClass(container);

      let element = null;

      if (mediaType === 'video' || mediaType === 'metafield') {
        element = this.mountHosted(container, { loop, muted, className });
      } else if (mediaType === 'external_video') {
        element = this.mountExternal(container, { autoplay, muted, className });
      }

      if (element) {
        container.dataset.vscMounted = 'true';
        this.bindReadyListeners(container, element);
      }

      return element;
    },

    unmount(container) {
      if (!container) return;

      const video = container.querySelector('video');
      if (video) {
        video.pause();
        video.onended = null;
        video.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('src');
          source.remove();
        });
        video.removeAttribute('src');
        video.load();
        video.remove();
      }

      const iframe = container.querySelector('iframe');
      if (iframe) {
        iframe.src = 'about:blank';
        iframe.remove();
      }

      const loader = container.querySelector('.vsc-media-loading');
      if (loader) loader.remove();

      container.dataset.vscMounted = 'false';
      container.dataset.vscLoading = 'false';
      this.restorePoster(container);
    },

    restorePoster(container) {
      if (!container) return;
      container.dataset.vscLoading = 'false';
      this.ensurePosterLayer(container);

      const loader = container.querySelector('.vsc-media-loading');
      if (loader) loader.remove();
    },

    getMediaElement(container) {
      return container?.querySelector('video, iframe') || null;
    },

    pause(container) {
      const video = container?.querySelector('video');
      if (video) video.pause();
    },

    play(container, options = {}) {
      const element = this.getMediaElement(container) || this.mount(container, options);
      if (!element) return Promise.resolve();

      if (element.tagName === 'VIDEO') {
        if (options.muted !== undefined) {
          element.muted = options.muted;
          element.defaultMuted = options.muted;
          if (options.muted) {
            element.setAttribute('muted', '');
          } else {
            element.removeAttribute('muted');
          }
        }
        return element.play().catch(() => {});
      }

      return Promise.resolve();
    }
  };

  function pauseAllPageVideos() {
    document.querySelectorAll('video').forEach((video) => video.pause());
  }

  class VideoStoriesCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.video-stories-carousel__track');
      this.prevBtn = section.querySelector('.video-stories-carousel__nav--prev');
      this.nextBtn = section.querySelector('.video-stories-carousel__nav--next');
      this.dotsEl = section.querySelector('[data-carousel-dots]');
      this.slides = Array.from(section.querySelectorAll('.video-stories-carousel__slide'));
      this.autoplayEnabled = section.dataset.videoAutoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.modal = section.querySelector('.video-stories-modal');
      this.suspended = false;
      this.activeMountIndices = new Set();
      this.syncRaf = null;
      this.pageCount = 0;
      this.onResize = () => {
        this.buildDots();
        this.updateNavState();
        this.scheduleSyncCarouselMedia();
      };

      if (!this.track || this.slides.length === 0) {
        this.markReady();
        return;
      }

      this.bindEvents();
      this.buildDots();
      this.updateNavState();
      this.hydrateVisibleMedia();
      requestAnimationFrame(() => this.markReady());

      if (this.modal) {
        this.storiesModal = new VideoStoriesModal(section, this);
      }
    }

    markReady() {
      this.section.dataset.vscReady = 'true';
      this.section.setAttribute('aria-busy', 'false');
    }

    hydrateVisibleMedia() {
      this.getVisibleIndices().forEach((index) => {
        const container = this.getMediaContainer(index);
        if (container?.dataset.vscPoster) {
          VideoStoriesMediaManager.restorePoster(container);
        }
      });

      const mountVideos = () => {
        if (this.suspended) return;
        this.syncCarouselMedia();
      };

      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(mountVideos, { timeout: 5000 });
      } else {
        setTimeout(mountVideos, 600);
      }
    }

    getColumns() {
      const value = parseFloat(getComputedStyle(this.section).getPropertyValue('--vsc-columns'));
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    getPageCount() {
      return Math.max(1, Math.ceil(this.slides.length / this.getColumns()));
    }

    getPageScrollLeft(pageIndex) {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (this.pageCount <= 1) return 0;
      return (maxScroll / (this.pageCount - 1)) * pageIndex;
    }

    getCurrentPage() {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (maxScroll <= 0 || this.pageCount <= 1) return 0;
      return Math.round((this.track.scrollLeft / maxScroll) * (this.pageCount - 1));
    }

    buildDots() {
      if (!this.dotsEl) return;

      const nextPageCount = this.getPageCount();
      if (nextPageCount === this.pageCount && this.dotsEl.childElementCount === nextPageCount) {
        this.updateDots();
        return;
      }

      this.pageCount = nextPageCount;
      this.dotsEl.innerHTML = '';

      if (this.pageCount <= 1) return;

      for (let i = 0; i < this.pageCount; i += 1) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'video-stories-carousel__dot';
        btn.setAttribute('aria-label', `Página ${i + 1}`);
        btn.addEventListener('click', () => this.scrollToPage(i));
        this.dotsEl.appendChild(btn);
      }

      this.updateDots();
    }

    updateDots() {
      if (!this.dotsEl || this.pageCount <= 1) return;
      const current = this.getCurrentPage();
      this.dotsEl.querySelectorAll('.video-stories-carousel__dot').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
    }

    scrollToPage(pageIndex) {
      this.track.scrollTo({
        left: this.getPageScrollLeft(pageIndex),
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });

      if (this.reducedMotion || !('onscrollend' in this.track)) {
        setTimeout(() => this.syncCarouselMedia(), 350);
        setTimeout(() => this.syncCarouselMedia(), 700);
      }
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn?.addEventListener('click', () => this.scroll('next'));
      this.track.addEventListener('scroll', () => {
        this.updateNavState();
        this.scheduleSyncCarouselMedia();
      }, { passive: true });
      this.track.addEventListener('scrollend', () => {
        this.syncCarouselMedia();
      }, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    getMediaContainer(slideIndex) {
      return this.slides[slideIndex]?.querySelector('[data-vsc-media]') || null;
    }

    isSlideVisibleInTrack(slide) {
      const trackRect = this.track.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      return slideRect.right > trackRect.left + 4 && slideRect.left < trackRect.right - 4;
    }

    getVisibleIndices() {
      const visible = [];
      this.slides.forEach((slide, index) => {
        if (this.isSlideVisibleInTrack(slide)) visible.push(index);
      });
      return visible;
    }

    getMountIndices() {
      return new Set(this.getVisibleIndices());
    }

    getAutoplayIndex(visibleIndices) {
      if (!this.autoplayEnabled || this.reducedMotion || !visibleIndices.length) return -1;
      return Math.min(...visibleIndices);
    }

    scheduleSyncCarouselMedia() {
      if (this.syncRaf) cancelAnimationFrame(this.syncRaf);
      this.syncRaf = requestAnimationFrame(() => {
        this.syncRaf = null;
        this.syncCarouselMedia();
      });
    }

    playCarouselHosted(container) {
      if (!container || !this.autoplayEnabled || this.reducedMotion || this.suspended) return;

      const slide = container.closest('.video-stories-carousel__slide');
      if (!slide || !this.isSlideVisibleInTrack(slide)) return;

      let element = VideoStoriesMediaManager.getMediaElement(container);
      if (!element || element.tagName !== 'VIDEO') {
        element = VideoStoriesMediaManager.mount(container, {
          autoplay: false,
          muted: true,
          context: 'carousel'
        });
      }
      if (!element || element.tagName !== 'VIDEO') return;

      element.muted = true;
      element.defaultMuted = true;
      if (element.preload === 'none') {
        element.preload = 'auto';
        element.load();
      }

      const tryPlay = () => {
        element.play().catch(() => {
          setTimeout(() => {
            if (this.isSlideVisibleInTrack(slide)) {
              element.play().catch(() => {});
            }
          }, 300);
        });
      };

      if (element.readyState >= 2) {
        tryPlay();
      } else {
        element.addEventListener('loadeddata', tryPlay, { once: true });
        element.addEventListener('canplay', tryPlay, { once: true });
      }
    }

    mountCarouselExternal(container, autoplay) {
      VideoStoriesMediaManager.unmount(container);
      VideoStoriesMediaManager.mount(container, {
        autoplay,
        muted: true,
        context: 'carousel'
      });
      container.dataset.vscAutoplayActive = autoplay ? 'true' : 'false';
    }

    syncCarouselMedia() {
      if (this.suspended) return;

      const visibleIndices = this.getVisibleIndices();
      const mountIndices = new Set(visibleIndices);
      const playIndex = this.getAutoplayIndex(visibleIndices);
      const prevMountIndices = this.activeMountIndices;

      visibleIndices.forEach((index) => {
        const container = this.getMediaContainer(index);
        if (container?.dataset.vscPoster) {
          VideoStoriesMediaManager.restorePoster(container);
        }
      });

      prevMountIndices.forEach((index) => {
        if (!mountIndices.has(index)) {
          const container = this.getMediaContainer(index);
          if (container) {
            VideoStoriesMediaManager.unmount(container);
            container.dataset.vscAutoplayActive = 'false';
          }
        }
      });

      mountIndices.forEach((index) => {
        const container = this.getMediaContainer(index);
        const slide = this.slides[index];
        if (!container || !slide) return;

        const shouldPlay = index === playIndex;
        const isExternal = container.dataset.vscMediaType === 'external_video';

        if (!VideoStoriesMediaManager.isMounted(container)) {
          if (shouldPlay) {
            this.mountCarouselExternal(container, shouldPlay && isExternal);
            if (!isExternal) this.playCarouselHosted(container);
          } else {
            VideoStoriesMediaManager.restorePoster(container);
          }
          return;
        }

        if (shouldPlay) {
          if (isExternal) {
            if (container.dataset.vscAutoplayActive !== 'true') {
              this.mountCarouselExternal(container, true);
            }
          } else {
            container.dataset.vscAutoplayActive = 'false';
            this.playCarouselHosted(container);
          }
          return;
        }

        container.dataset.vscAutoplayActive = 'false';
        if (isExternal && VideoStoriesMediaManager.isMounted(container)) {
          this.mountCarouselExternal(container, false);
        } else {
          VideoStoriesMediaManager.pause(container);
        }
      });

      this.activeMountIndices = new Set(
        [...mountIndices].filter((index) => {
          const container = this.getMediaContainer(index);
          return container && VideoStoriesMediaManager.isMounted(container);
        })
      );
    }

    suspendAll() {
      this.suspended = true;
      this.slides.forEach((slide) => {
        const container = slide.querySelector('[data-vsc-media]');
        if (container) VideoStoriesMediaManager.unmount(container);
      });
      this.activeMountIndices = new Set();
    }

    resumeVisible() {
      this.suspended = false;
      this.syncCarouselMedia();
    }

    getScrollAmount() {
      const slide = this.slides[0];
      if (!slide) return 0;
      const gap = parseFloat(getComputedStyle(this.section).getPropertyValue('--vsc-gap')) || 16;
      return slide.offsetWidth + gap;
    }

    scroll(direction) {
      const amount = this.getScrollAmount();
      this.track.scrollBy({
        left: direction === 'next' ? amount : -amount,
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });

      if (this.reducedMotion || !('onscrollend' in this.track)) {
        setTimeout(() => this.syncCarouselMedia(), 350);
        setTimeout(() => this.syncCarouselMedia(), 700);
      }
    }

    updateNavState() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const tolerance = 2;

      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.disabled = this.track.scrollLeft <= tolerance;
        this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - tolerance;
      }

      this.updateDots();
    }

    destroy() {
      window.removeEventListener('resize', this.onResize);
      if (this.syncRaf) cancelAnimationFrame(this.syncRaf);
      this.suspendAll();
      this.storiesModal?.destroy();
    }
  }

  class VideoStoriesModal {
    constructor(section, carousel) {
      this.section = section;
      this.carousel = carousel;
      this.modal = section.querySelector('.video-stories-modal');
      this.stories = Array.from(section.querySelectorAll('.video-stories-modal__story'));
      this.progressEl = section.querySelector('[data-story-progress]');
      this.currentIndex = 0;
      this.isMuted = true;
      this.progressRaf = null;
      this.swipeStartX = 0;
      this.swipeStartY = 0;
      this.swipeActive = false;
      this.swiped = false;

      if (!this.modal || this.stories.length === 0) return;

      this.buildProgress();
      this.bindEvents();
    }

    bindEvents() {
      this.section.querySelectorAll('[data-story-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const index = parseInt(trigger.dataset.storyOpen, 10);
          this.open(index);
        });
      });

      this.modal.querySelectorAll('[data-story-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.modal.querySelectorAll('[data-story-prev]').forEach((el) => {
        el.addEventListener('click', (event) => {
          if (this.swiped) {
            event.preventDefault();
            event.stopPropagation();
            this.swiped = false;
            return;
          }
          this.prev();
        });
      });

      this.modal.querySelectorAll('[data-story-next]').forEach((el) => {
        el.addEventListener('click', (event) => {
          if (this.swiped) {
            event.preventDefault();
            event.stopPropagation();
            this.swiped = false;
            return;
          }
          this.next();
        });
      });

      this.modal.querySelectorAll('[data-story-mute]').forEach((el) => {
        el.addEventListener('click', () => this.toggleMute());
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
          this.close();
          return;
        }
        if (!this.modal.classList.contains('is-open')) return;
        if (event.key === 'ArrowLeft') this.prev();
        if (event.key === 'ArrowRight') this.next();
      });

      this.bindSwipeEvents();
    }

    bindSwipeEvents() {
      const surface = this.modal.querySelector('.video-stories-modal__viewport') || this.modal;
      const threshold = 50;

      const onStart = (clientX, clientY) => {
        this.swipeStartX = clientX;
        this.swipeStartY = clientY;
        this.swipeActive = true;
        this.swiped = false;
      };

      const onEnd = (clientX, clientY) => {
        if (!this.swipeActive || !this.modal.classList.contains('is-open')) {
          this.swipeActive = false;
          return;
        }

        const dx = clientX - this.swipeStartX;
        const dy = clientY - this.swipeStartY;
        this.swipeActive = false;

        if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;

        this.swiped = true;
        if (dx < 0) this.next();
        else this.prev();

        setTimeout(() => {
          this.swiped = false;
        }, 50);
      };

      surface.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        onStart(touch.clientX, touch.clientY);
      }, { passive: true });

      surface.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        onEnd(touch.clientX, touch.clientY);
      }, { passive: true });

      surface.addEventListener('touchcancel', () => {
        this.swipeActive = false;
      }, { passive: true });

      surface.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, [data-story-mute], [data-story-close]')) return;
        onStart(event.clientX, event.clientY);
      });

      surface.addEventListener('pointerup', (event) => {
        onEnd(event.clientX, event.clientY);
      });

      surface.addEventListener('pointercancel', () => {
        this.swipeActive = false;
      });
    }

    buildProgress() {
      if (!this.progressEl) return;
      this.progressEl.innerHTML = '';
      this.stories.forEach((_, index) => {
        const segment = document.createElement('div');
        segment.className = 'video-stories-modal__progress-segment';
        segment.dataset.segmentIndex = index;
        const fill = document.createElement('span');
        fill.className = 'video-stories-modal__progress-fill';
        segment.appendChild(fill);
        this.progressEl.appendChild(segment);
      });
      this.segments = Array.from(this.progressEl.querySelectorAll('.video-stories-modal__progress-segment'));
    }

    getStoryMediaContainer(story) {
      return story?.querySelector('[data-vsc-media]') || null;
    }

    open(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.stories.length - 1));
      this.modal.hidden = false;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('video-stories-modal-open');
      this.carousel.suspendAll();
      pauseAllPageVideos();
      this.syncMuteButtons();
      this.showStory(this.currentIndex);
    }

    close() {
      this.pauseAllStories();
      this.stories.forEach((story) => {
        const container = this.getStoryMediaContainer(story);
        if (container) {
          VideoStoriesMediaManager.unmount(container);
          VideoStoriesMediaManager.restorePoster(container);
        }
      });
      cancelAnimationFrame(this.progressRaf);
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('video-stories-modal-open');
      this.carousel.resumeVisible();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.showStory(this.currentIndex - 1);
      } else {
        this.close();
      }
    }

    next() {
      if (this.currentIndex < this.stories.length - 1) {
        this.showStory(this.currentIndex + 1);
      } else {
        this.close();
      }
    }

    showStory(index) {
      this.currentIndex = index;
      this.stories.forEach((story, i) => {
        story.classList.remove('is-active', 'is-adjacent');
        if (i === index) {
          story.classList.add('is-active');
        } else if (i === index - 1 || i === index + 1) {
          story.classList.add('is-adjacent');
        }
      });

      this.stories.forEach((story) => {
        const container = this.getStoryMediaContainer(story);
        if (container) {
          VideoStoriesMediaManager.unmount(container);
          VideoStoriesMediaManager.restorePoster(container);
        }
      });

      const activeContainer = this.getStoryMediaContainer(this.stories[index]);
      if (activeContainer) {
        const isExternal = activeContainer.dataset.vscMediaType === 'external_video';
        VideoStoriesMediaManager.mount(activeContainer, {
          autoplay: isExternal,
          muted: this.isMuted,
          context: 'modal'
        });
      }

      this.updateProgressUI();
      this.playActiveStory();
    }

    getActiveVideo() {
      const container = this.getStoryMediaContainer(this.stories[this.currentIndex]);
      const element = container ? VideoStoriesMediaManager.getMediaElement(container) : null;
      return element?.tagName === 'VIDEO' ? element : null;
    }

    playActiveStory() {
      this.pauseAllStories();

      const container = this.getStoryMediaContainer(this.stories[this.currentIndex]);
      const element = container ? VideoStoriesMediaManager.getMediaElement(container) : null;

      if (!element || element.tagName !== 'VIDEO') {
        this.startFallbackProgress(element?.tagName === 'IFRAME' ? 15000 : 5000);
        return;
      }

      element.currentTime = 0;
      element.muted = this.isMuted;

      const startPlayback = () => {
        element.play().catch(() => {});
        element.onended = () => this.next();
        this.trackProgress(element);
      };

      if (element.readyState >= 2) {
        startPlayback();
      } else {
        element.addEventListener('loadeddata', startPlayback, { once: true });
      }
    }

    pauseAllStories() {
      this.stories.forEach((story) => {
        const container = this.getStoryMediaContainer(story);
        if (!container) return;

        VideoStoriesMediaManager.pause(container);
        const video = container.querySelector('video');
        if (video) video.onended = null;
      });
      cancelAnimationFrame(this.progressRaf);
    }

    trackProgress(video) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const update = () => {
        if (!video.duration || Number.isNaN(video.duration)) {
          this.progressRaf = requestAnimationFrame(update);
          return;
        }
        fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
        if (!video.paused && !video.ended) {
          this.progressRaf = requestAnimationFrame(update);
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(update);
    }

    startFallbackProgress(duration) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        fill.style.width = `${progress * 100}%`;
        if (progress < 1) {
          this.progressRaf = requestAnimationFrame(tick);
        } else {
          this.next();
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(tick);
    }

    updateProgressUI() {
      this.segments.forEach((segment, i) => {
        const fill = segment.querySelector('.video-stories-modal__progress-fill');
        segment.classList.toggle('is-complete', i < this.currentIndex);
        if (fill) fill.style.width = i < this.currentIndex ? '100%' : '0%';
      });
    }

    syncMuteButtons() {
      this.modal.querySelectorAll('[data-story-mute]').forEach((btn) => {
        btn.classList.toggle('is-muted', this.isMuted);
        btn.setAttribute('aria-label', this.isMuted ? 'Ativar som' : 'Desativar som');
      });
    }

    toggleMute() {
      this.isMuted = !this.isMuted;
      const video = this.getActiveVideo();
      if (video) video.muted = this.isMuted;
      this.syncMuteButtons();
    }

    destroy() {
      cancelAnimationFrame(this.progressRaf);
    }
  }

  function initVideoStoriesSection(section) {
    if (!section || section.dataset.vscJsReady === 'true') return;
    section._videoStoriesCarousel?.destroy?.();
    section._videoStoriesCarousel = new VideoStoriesCarousel(section);
    section.dataset.vscJsReady = 'true';
  }

  function whenHomeImagesLoaded(callback) {
    const root = document.querySelector('main') || document;
    const images = Array.from(root.querySelectorAll('img'));
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      callback();
    };

    const pending = images.filter((img) => !(img.complete && img.naturalWidth > 0));
    if (!pending.length) {
      finish();
      return;
    }

    let remaining = pending.length;
    const onDone = () => {
      remaining -= 1;
      if (remaining <= 0) finish();
    };

    pending.forEach((img) => {
      img.addEventListener('load', onDone, { once: true });
      img.addEventListener('error', onDone, { once: true });
    });

    setTimeout(finish, 20000);
  }

  function whenPageSettled(callback) {
    const afterImages = () => {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => callback(), { timeout: 8000 });
        return;
      }
      setTimeout(callback, 800);
    };

    const start = () => whenHomeImagesLoaded(afterImages);

    if (document.readyState === 'complete') {
      start();
      return;
    }

    window.addEventListener('load', start, { once: true });
  }

  function bootVideoStories({ immediate = false } = {}) {
    const sections = document.querySelectorAll('.video-stories-carousel[data-section-id]');
    if (!sections.length) return;

    if (immediate) {
      sections.forEach(initVideoStoriesSection);
      return;
    }

    whenPageSettled(() => {
      sections.forEach(initVideoStoriesSection);
    });
  }

  bootVideoStories();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.video-stories-carousel[data-section-id]');
    if (section) {
      delete section.dataset.vscJsReady;
      section.dataset.vscReady = 'false';
      section.setAttribute('aria-busy', 'true');
    }
    initVideoStoriesSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.video-stories-carousel[data-section-id]');
    if (section?._videoStoriesCarousel?.destroy) {
      section._videoStoriesCarousel.destroy();
      delete section._videoStoriesCarousel;
      delete section.dataset.vscJsReady;
    }
  });

  window.__VideoStoriesLoaded = true;

  } catch(e) { console.error(e); }
})();
})();
